export default "__VITE_ASSET__1injnrnA__"